var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedUserBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_4665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4322 1.79555L4.43219 4.90555C3.71219 5.22555 3.24219 5.94555 3.24219 6.73555V11.4355C3.24219 16.9855 7.08219 22.1755 12.2422 23.4355C17.4022 22.1755 21.2422 16.9855 21.2422 11.4355V6.73555C21.2422 5.94555 20.7722 5.22555 20.0522 4.90555L13.0522 1.79555C12.5422 1.56555 11.9422 1.56555 11.4322 1.79555ZM9.53219 16.7255L6.94219 14.1355C6.55219 13.7455 6.55219 13.1155 6.94219 12.7255C7.33219 12.3355 7.96219 12.3355 8.35219 12.7255L10.2422 14.6055L16.1222 8.72555C16.5122 8.33555 17.1422 8.33555 17.5322 8.72555C17.9222 9.11555 17.9222 9.74555 17.5322 10.1355L10.9422 16.7255C10.5622 17.1155 9.92219 17.1155 9.53219 16.7255Z",
    fill: "#444CE7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_4665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.794922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedUserBlue);
export default __webpack_public_path__ + "static/media/VerifiedUserBlue.34fc459158267e77e34a224d8aa248a5.svg";
export { ForwardRef as ReactComponent };